"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./doesGlobalFileReaderExist"));
__export(require("./doesGlobalWebSocketExist"));
__export(require("./protocol-base"));
//# sourceMappingURL=index.js.map